import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TTumiorosisakiDeleteReq,
  TTumiorosisakiHaisiReq,
  TTumiorosisakiListGetReq,
  TTumiorosisakiListGetRes,
  TTumiorosisakiPostReq,
  TTumiorosisakiPutReq,
} from "./TTumiorosisaki"

/**
 * 積卸先マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class TumiorosisakiService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TTumiorosisakiListGetReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TTumiorosisakiListGetRes[]>> =
        await this.postInner(`/master/tumiorosi/list`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TMenuInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TTumiorosisakiListGetRes>> =
        await this.getInner(`/master/tumiorosi/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TTumiorosisakiPostReq, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> =
        await this.postFormDataInner(`/master/tumiorosi`, data, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (
    id: number,
    data: TTumiorosisakiPutReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> =
        await this.putFormDataInner(`master/tumiorosi/${id}`, data, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体削除
   *
   * @param {TTumiorosisakiDeleteReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof TumiorosisakiService
   */
  delete = async (
    id: number,
    data: TTumiorosisakiDeleteReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `master/tumiorosi/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 廃止登録
   *
   * @param {TTumiorosisakiHaisiReq} data
   * @param {(param: TApiResponse<boolean>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<boolean>>) => any} reject
   * @memberof TumiorosisakiService
   */
  haisi = async (
    id: number,
    data: TTumiorosisakiHaisiReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/tumiorosi/${id}/haisi`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 廃止解除
   * @param id
   * @param data
   */
  haisiKaizyo = async (
    id: number,
    data: TTumiorosisakiHaisiReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/tumiorosi/${id}/haisi/delete`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
